const initialState = {
  title: 'Dashboard',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'SET_TITLE':
      return { ...state, ...rest }
    default:
      return state
  }
}

export default changeState
